import { AbstractControl, FormArray, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import dayjs from 'dayjs';

export type FormGroupControls<T> = {
  [K in keyof T]: T[K] extends File
    ? FormControl<T[K]>
    : T[K] extends Array<infer U>
    ? FormArray<FormGroup<FormGroupControls<U>>>
    : T[K] extends object
    ? FormGroup<FormGroupControls<T[K]>>
    : FormControl<T[K]>;
};

export const addValidator = (control: FormControl | AbstractControl, validators: ValidatorFn[]): void => {
  control.addValidators(validators);
  control.updateValueAndValidity({ emitEvent: false });
};

export const removeValidator = (control: FormControl | AbstractControl, validators: ValidatorFn[]): void => {
  control.removeValidators(validators);
  control.updateValueAndValidity({ emitEvent: false });
};

export const formatObjectToDate = (dateObj: { day: number; month: number; year: number }): string => {
  // Note: In Day.js, months are 0-indexed (January is 0), so subtract 1 from month
  return dayjs(new Date(dateObj.year, dateObj.month - 1, dateObj.day)).format('YYYY-MM-DD');
};

export const deepCopy = <T>(obj: T): T => JSON.parse(JSON.stringify(obj));
